import React, { useEffect } from 'react';
import i18n from 'i18next';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getFromStore, saveToStore } from 'utils/storeHelpers';
import { languages } from 'lang';

const LanguageSelect = ({ className = '' }) => {
  const history = useHistory();
  const location = useLocation();
  const defaultLang = getFromStore('lang') || 'en';
  const [language, setLanguage] = useState(defaultLang);

  const onChangeLanguage = async lang => {
    const langCode = typeof lang === 'string' ? lang.split('-')[0] : lang;
    setLanguage(langCode);
    saveToStore('lang', langCode);

    // Change language in i18n
    await i18n.changeLanguage(langCode);

    // Update URL based on language
    const currentPath = location.pathname;
    const currentLangMatch = currentPath.match(/^\/de(\/|$)/);

    let newPath;
    if (langCode === 'en') {
      // Switching to English - remove /de/ prefix if present
      if (currentLangMatch) {
        newPath = currentPath.replace(/^\/de/, '') || '/';
      } else {
        // Already no language prefix (already English)
        newPath = currentPath;
      }
    } else if (langCode === 'de') {
      // Switching to German - add /de/ prefix
      if (currentLangMatch) {
        // Already has /de/ prefix
        newPath = currentPath;
      } else {
        // Add /de/ prefix
        newPath = currentPath === '/' ? '/de' : `/de${currentPath}`;
      }
    }

    // Navigate to new path with language
    history.push(newPath + location.search);
  };

  useEffect(() => {
    const storedLang = getFromStore('lang') || 'en';
    const langCode = storedLang.split('-')[0];
    setLanguage(langCode);

    // Ensure i18n is using the stored language
    if (i18n.language !== langCode) {
      i18n.changeLanguage(langCode);
    }
  }, []);

  return (
    <div className={`language-select-simple ${className || ''}`}>
      {languages.map((item, index) => {
        const isActive = item.code === language || item.value === language || item.value.startsWith(language);
        return (
          <React.Fragment key={item.code}>
            <button
              className={`language-select-simple__button ${isActive ? 'active' : ''}`}
              onClick={() => onChangeLanguage(item.code)}
              type='button'
            >
              {item.name}
            </button>
            {index < languages.length - 1 && <span className='language-select-simple__separator'>|</span>}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguageSelect;
